import React from 'react';
import ReactDOM from 'react-dom/client';
// Components
import App from './App';
// Global CSS
import GlobalStyled from "./Components/GlobalStyled/GlobalStyled.jsx";
// Redux - Provide
import { Provider } from 'react-redux';
// Import Store
import store from './Redux/configStore'
//Router
import {HashRouter} from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        // set Store range
        <Provider store={store}>
            <HashRouter>
                {/* Global CSS */}
                <GlobalStyled />
                <App />
            </HashRouter>
        </Provider>
);
